import { useCallback, useContext } from 'react';

import ReportGadgetsContext from 'contexts/ReportGadgetsContext';

import isFilterUsedInChart from '../isFilterUsedInChart';
import useGetIsUsedInMetricId from './useGetIsUsedInMetricId';

const useGetChartDefinitionUsage = () => {
  const { allGadgets } = useContext(ReportGadgetsContext);
  const getIsUsedInMetricId = useGetIsUsedInMetricId();

  const getChartDefinitionUsage = useCallback(
    (filter: SavedFilter): VisualisationDefinition[] => {
      return allGadgets
        .map((g) => g.chartDef)
        .filter((def) => {
          return isFilterUsedInChart(filter, def, getIsUsedInMetricId);
        });
    },
    [allGadgets, getIsUsedInMetricId],
  );

  return getChartDefinitionUsage;
};

export default useGetChartDefinitionUsage;
